import React, { useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faQuoteLeft, faStar } from '@fortawesome/free-solid-svg-icons';
import SectionTitle from '../UI/SectionTitle';
import Button, { ButtonVariants } from '../UI/Button';
import ReviewCard from '../UI/ReviewCard';
import { Form, FormInput, FormTextarea, FormButton } from '../UI/Form';

// Демо-данные отзывов
const reviewsData = [
  {
    id: 1,
    name: 'Иван Петров',
    location: 'Москва',
    text: 'Заказал 100 рулонов для склада, доставили на следующий день. Качество отличное, цены радуют! Буду обращаться снова и рекомендовать партнерам.',
    image: 'https://randomuser.me/api/portraits/men/32.jpg'
  },
  {
    id: 2,
    name: 'Елена Смирнова',
    location: 'Санкт-Петербург',
    text: 'Очень порадовала быстрая доставка и качество пленки. Используем для упаковки нашей продукции, все прекрасно держится. Спасибо за профессионализм!',
    image: 'https://randomuser.me/api/portraits/women/44.jpg'
  },
  {
    id: 3,
    name: 'Алексей Иванов',
    location: 'Екатеринбург',
    text: 'Уже второй раз заказываем большую партию пленки. Всегда приходит вовремя, качество стабильно высокое. Менеджеры всегда на связи и готовы помочь с выбором.',
    image: 'https://randomuser.me/api/portraits/men/62.jpg'
  },
  {
    id: 4,
    name: 'Ольга Козлова',
    location: 'Новосибирск',
    text: 'Долго выбирали поставщика стрейч-пленки для нашего производства. Купить-Стрейч.РФ оказались лучшими по соотношению цена-качество. Надежный партнер!',
    image: 'https://randomuser.me/api/portraits/women/58.jpg'
  },
  {
    id: 5,
    name: 'Дмитрий Соколов',
    location: 'Казань',
    text: 'Впервые использовали стрейч-пленку от Купить-Стрейч.РФ для переезда офиса. Все оборудование доехало в целости и сохранности. Отличное качество!',
    image: 'https://randomuser.me/api/portraits/men/22.jpg'
  }
];

const ReviewsSection = styled.section`
  padding: var(--spacing-xxl) 0;
  background-color: var(--color-background-alt);
`;

const ReviewsContainer = styled.div`
  max-width: var(--container-width);
  padding: 0 var(--container-padding);
  margin: 0 auto;
`;

const ReviewsSlider = styled.div`
  margin-bottom: var(--spacing-xl);
  position: relative;
  padding: 0 30px;
  
  .slick-slide {
    padding: 0 var(--spacing-sm);
    opacity: 0.7;
    transform: scale(0.9);
    transition: all 0.8s ease;
  }
  
  .slick-center, 
  .slick-current, 
  .slick-active {
    opacity: 1;
    transform: scale(1);
  }
  
  .slick-dots {
    bottom: -40px;
    
    li {
      margin: 0 5px;
      
      button {
        &:before {
          font-size: 12px;
          color: var(--color-primary);
          opacity: 0.5;
          transition: all 0.3s ease;
        }
      }
      
      &.slick-active button:before {
        opacity: 1;
        color: var(--color-primary);
        transform: scale(1.2);
      }
    }
  }
  
  .slick-prev, 
  .slick-next {
    z-index: 1;
    width: 40px;
    height: 40px;
    background-color: white;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;
    
    &:before {
      font-size: 20px;
      color: var(--color-primary);
      opacity: 1;
      transition: all 0.3s ease;
    }
    
    &:hover {
      background-color: var(--color-primary);
      transform: scale(1.1);
      
      &:before {
        color: white;
      }
    }
  }
  
  .slick-prev {
    left: -5px;
  }
  
  .slick-next {
    right: -5px;
  }
`;

const ReviewsActions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-lg);
`;

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
  padding: var(--spacing-md);
`;

const ModalContainer = styled(motion.div)`
  background-color: white;
  border-radius: var(--border-radius-lg);
  width: 100%;
  max-width: 600px;
  overflow: hidden;
  position: relative;
  box-shadow: var(--shadow-lg);
`;

const ModalHeader = styled.div`
  background-color: var(--color-primary);
  color: white;
  padding: var(--spacing-lg) var(--spacing-md);
  position: relative;
`;

const ModalTitle = styled.h3`
  margin: 0;
  font-size: 1.4rem;
  display: flex;
  align-items: center;
  
  svg {
    margin-right: var(--spacing-sm);
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  padding: var(--spacing-xl) var(--spacing-lg);
`;

const RatingContainer = styled.div`
  margin-bottom: var(--spacing-lg);
`;

const RatingLabel = styled.div`
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: var(--spacing-xs);
  color: var(--color-text-light);
`;

const RatingStars = styled.div`
  display: flex;
  gap: var(--spacing-xs);
`;

const StarIcon = styled.div`
  color: ${({ active }) => active ? '#FFC107' : '#E0E0E0'};
  font-size: 1.8rem;
  cursor: pointer;
  transition: transform var(--transition-fast);
  
  &:hover {
    transform: scale(1.1);
  }
`;

const SuccessMessage = styled.div`
  text-align: center;
  padding: var(--spacing-lg) 0;
  
  h3 {
    color: var(--color-primary);
    margin-bottom: var(--spacing-md);
  }
  
  p {
    margin-bottom: var(--spacing-lg);
  }
`;

const Reviews = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [hoveredRating, setHoveredRating] = useState(0);
  const [formData, setFormData] = useState({
    name: '',
    location: '',
    text: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    cssEase: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
    fade: false,
    arrows: true,
    centerMode: false,
    beforeChange: (current, next) => {
      console.log(`Changing from slide ${current} to ${next}`);
    },
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          centerMode: false,
          autoplaySpeed: 8000
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '30px',
          autoplaySpeed: 6000
        }
      }
    ]
  };
  
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const handleAfterChange = (index) => {
    setCurrentSlide(index);
  };
  
  const updatedSliderSettings = {
    ...sliderSettings,
    afterChange: handleAfterChange
  };
  
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  
  const handleCloseModal = () => {
    setIsModalOpen(false);
    // Сбрасываем состояние формы при закрытии
    if (isSubmitted) {
      setIsSubmitted(false);
      setRating(0);
      setFormData({
        name: '',
        location: '',
        text: ''
      });
    }
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // В реальном проекте здесь будет отправка данных на сервер
    console.log('Данные формы:', { ...formData, rating });
    setIsSubmitted(true);
  };
  
  return (
    <ReviewsSection id="reviews">
      <ReviewsContainer>
        <SectionTitle
          title="Отзывы наших клиентов"
          subtitle="Нам доверяют сотни компаний и частных клиентов. Вот что они говорят о нас"
        />
        
        <ReviewsSlider>
          <Slider {...updatedSliderSettings}>
            {reviewsData.map((review, index) => (
              <div key={review.id}>
                <motion.div
                  initial={{ opacity: 0.6, y: 20 }}
                  animate={{ 
                    opacity: currentSlide === index ? 1 : 0.8,
                    y: 0,
                    scale: currentSlide === index ? 1.02 : 1
                  }}
                  transition={{ 
                    duration: 0.8,
                    ease: "easeOut"
                  }}
                >
                  <ReviewCard review={review} />
                </motion.div>
              </div>
            ))}
          </Slider>
        </ReviewsSlider>
        
        <ReviewsActions>
          <Button
            variant={'contained'}
            onClick={handleOpenModal}
          >
            Оставить отзыв
          </Button>
        </ReviewsActions>
      </ReviewsContainer>
      
      <AnimatePresence>
        {isModalOpen && (
          <Overlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleCloseModal}
          >
            <ModalContainer
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ type: 'spring', stiffness: 300, damping: 25 }}
              onClick={(e) => e.stopPropagation()}
            >
              <ModalHeader>
                <ModalTitle>
                  <FontAwesomeIcon icon={faQuoteLeft} />
                  Оставить отзыв
                </ModalTitle>
                <CloseButton onClick={handleCloseModal}>
                  <FontAwesomeIcon icon={faTimes} />
                </CloseButton>
              </ModalHeader>
              
              <ModalContent>
                {isSubmitted ? (
                  <SuccessMessage>
                    <h3>Спасибо за ваш отзыв!</h3>
                    <p>Мы очень ценим ваше мнение. Ваш отзыв будет опубликован после модерации.</p>
                    <Button
                      variant={'contained'}
                      onClick={handleCloseModal}
                    >
                      Закрыть
                    </Button>
                  </SuccessMessage>
                ) : (
                  <Form onSubmit={handleSubmit}>
                    <RatingContainer>
                      <RatingLabel>Оцените нашу продукцию и сервис</RatingLabel>
                      <RatingStars>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <StarIcon
                            key={star}
                            active={star <= (hoveredRating || rating)}
                            onClick={() => setRating(star)}
                            onMouseEnter={() => setHoveredRating(star)}
                            onMouseLeave={() => setHoveredRating(0)}
                          >
                            <FontAwesomeIcon icon={faStar} />
                          </StarIcon>
                        ))}
                      </RatingStars>
                    </RatingContainer>
                    
                    <FormInput
                      id="review-name"
                      name="name"
                      label="Ваше имя"
                      placeholder="Введите ваше имя"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                    
                    <FormInput
                      id="review-location"
                      name="location"
                      label="Город"
                      placeholder="Укажите ваш город"
                      value={formData.location}
                      onChange={handleInputChange}
                      required
                    />
                    
                    <FormTextarea
                      id="review-text"
                      name="text"
                      label="Ваш отзыв"
                      placeholder="Поделитесь вашими впечатлениями о нашей продукции и сервисе"
                      value={formData.text}
                      onChange={handleInputChange}
                      required
                    />
                    
                    <FormButton
                      type="submit"
                      variant={'contained'}
                      fullWidth
                      disabled={!rating || !formData.name || !formData.location || !formData.text}
                    >
                      Отправить отзыв
                    </FormButton>
                  </Form>
                )}
              </ModalContent>
            </ModalContainer>
          </Overlay>
        )}
      </AnimatePresence>
    </ReviewsSection>
  );
};

export default Reviews; 